import { useState } from 'react';
import { TypeLeadCategory } from '../../form/form-fields/TypeLeadCategory';

const FilterItemCategory = ({ item, onChange, checked }) => {
  const [dataCollection, setDataCollection] = useState(
    item.dataCollection || {}
  );

  function handleChange(key, value) {
    const newDataCollection = { ...dataCollection, [key]: value };
    setDataCollection(newDataCollection);

    const selectedIds = Array.isArray(value)
      ? value.map((v) => v.id).join(`&${key}[]=`)
      : value?.id;

    if (selectedIds) {
      onChange({
        ...item,
        value: `${item.baseValue}${selectedIds}`,
        active: true,
        dataCollection: newDataCollection,
      });
    } else {
      onChange({
        ...item,
        value: ``,
        active: false,
        dataCollection: newDataCollection,
      });
    }
  }

  return (
    <TypeLeadCategory
      dataCollection={item.dataCollection}
      errors={{}}
      updateValidationOnChange={handleChange}
      field={{
        label: item.label,
        key: 'category',
      }}
      allowSelection={true}
    />
  );
};

export default FilterItemCategory;
